import React from "react";
import Helmet from "react-helmet";
import Section from "../../components/shared-ui/Section/Section";
import PEDLayout from "./PEDLayout";
import PEDHeroHeader from "../../components/HeroHeader/PEDHeroHeader";

import "../../css/PED/StayConnectedThankYou.scss";

export default function StayConnectedThankYou() {
  return (
    <React.Fragment>
      <Helmet>
        <title>Thank You!</title>
        <meta name="description" content="Thank You for Connecting with Treatment" />
      </Helmet>
      <PEDLayout pageClass="ped-resources-stay-connected-thank-you">
        <PEDHeroHeader
          extraClass="large-hero inner-bg home-hero"
          markup={
            <>
              <h1>NICE!</h1>
              <p>
                You’ve successfully signed up—look out for persistent and
                chronic ITP tools and tips flowing your way!
              </p>
            </>
          }
          maxWidth="525"
          bgImage={[
            "/images/ped/hero/sign-up-hero-desktop.jpg",
            "/images/ped/hero/sign-up-hero-desktop.jpg",
          ]}
          bgImageMobile={[
            "/images/ped/hero/sign-up-hero.png",
            "/images/ped/hero/sign-up-hero@2x.png",
          ]}
        />
        <Section sectionClass="section-padding thank-you-section">
          <h2>KEEP LEARNING</h2>
          <div className="thank-you-buttons">
            <a href="/pediatric-itp/what-is-doptelet-for-children/" className="btn btn-primary btn-arrow">
              <span>Doptelet for Children</span>
            </a>
            <a
              href="/pediatric-itp/support-and-resources/itp-caregiver-resources/"
              className="btn btn-primary btn-arrow"
            >
              <span>MORE ITP RESOURCES</span>
            </a>
          </div>
          <div className="thank-you-social">
            <a
              href="https://www.facebook.com/doptelet/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/images/ped/icons/icon-facebook@2x.png" alt="" />
            </a>
            <a
              href="https://www.youtube.com/@dopteletavatrombopag5013"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="icon-yt"
                src="/images/ped/icons/icon-yt@2x.png"
                alt=""
              />
            </a>
            <a
              href="https://www.instagram.com/doptelet_avatrombopag/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/images/ped/icons/icon-IG@2x.png" alt="" />
            </a>
          </div>
        </Section>

        <Section sectionClass="section-padding">
          <div className="more-information">
            <div className="more-info-content">
              <h2>Looking for more information about pediatric ITP?</h2>
              <p>
                Learn about the different types of pediatric ITP and how they
                are treated.
              </p>
            </div>
            <div className="more-info-cta">
              <a
                href="/pediatric-itp/what-is-itp-in-children/"
                className="btn btn-primary btn-arrow"
              >
                <span>What is Pediatric ITP</span>
              </a>
            </div>
          </div>
        </Section>
      </PEDLayout>
    </React.Fragment>
  );
}
